import React, { useEffect, useRef, useState } from 'react';

interface UpgradeConsiderationProps {
  conditions: string[];
}

export default function UpgradeConsideration({ conditions }: UpgradeConsiderationProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-cream-light px-5 py-10 md:px-8 md:py-14">
      <div
        className={`mx-auto max-w-[480px] transition-all duration-700 md:max-w-[700px] ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <div className="mb-6 flex items-center gap-2">
          <div className="h-px w-6 bg-softgold/40" />
          <span className="text-[11px] font-medium tracking-wider text-softgold">
            업그레이드 가이드
          </span>
        </div>

        <h2 className="mb-6 text-[18px] font-semibold tracking-tight text-navy md:text-[20px]">
          수제/비스포크도 고려해볼 만한 경우
        </h2>

        <div className="rounded-xl border border-navy/8 bg-cream px-5 py-6 md:px-6 md:py-7">
          <p className="mb-5 text-[13px] leading-relaxed text-navy/60 md:text-[14px]">
            반수제를 기본 추천으로 드리지만, 아래에 해당하신다면 수제나 비스포크도
            한 번쯤 고려해볼 만합니다.
          </p>

          <div className="space-y-3">
            {conditions.map((condition, i) => (
              <div
                key={i}
                className="flex items-start gap-3 rounded-lg border border-navy/5 bg-cream-light/60 px-4 py-3"
              >
                <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-softgold/10">
                  <i className="ri-arrow-up-line text-[11px] text-softgold" />
                </div>
                <span className="text-[13px] leading-relaxed text-navy/80">
                  {condition}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}